import React, { memo } from 'react';
import { NodeProps } from 'reactflow';
import { Bot, Brain, Search, Database, GitBranch } from 'lucide-react';
import WhatsAppStyleNode from './WhatsAppStyleNode';
import { ChatbotNodeData } from '../../types/nodes';

const chatbotIcons = {
  ai_response: <Bot />,
  intent_detection: <Brain />,
  entity_extraction: <Search />,
  context_manager: <Database />,
  conversation_flow: <GitBranch />
};

const chatbotLabels = {
  ai_response: 'Risposta AI',
  intent_detection: 'Rilevamento Intent',
  entity_extraction: 'Estrazione Entità',
  context_manager: 'Gestore Contesto',
  conversation_flow: 'Flusso Conversazione'
};

const ChatbotNode: React.FC<NodeProps<ChatbotNodeData>> = memo(({ selected, data }) => {
  const icon = chatbotIcons[data.chatbotType] || <Bot />;
  const label = chatbotLabels[data.chatbotType] || 'Chatbot';
  
  const getPreview = () => {
    switch (data.chatbotType) {
      case 'ai_response':
        return data.config.aiModel || 'GPT-3.5';
      case 'intent_detection':
        return `${data.config.intents?.length || 0} intent`;
      case 'entity_extraction':
        return `${data.config.entities?.length || 0} entità`;
      case 'context_manager':
        return `${data.config.contextVariables?.length || 0} variabili`;
      case 'conversation_flow':
        return `${data.config.conversationSteps?.length || 0} passi`;
      default:
        return null;
    }
  };

  return (
    <WhatsAppStyleNode
      selected={selected}
      icon={icon}
      label={label}
      preview={getPreview()}
      color="from-cyan-500 to-sky-600"
      handles={{
        target: true,
        source: true,
      }}
    />
  );
});

ChatbotNode.displayName = 'ChatbotNode';

export default ChatbotNode;
